import Phaser from "phaser";
import ImageHelpers from "./ImageHelpers";

export default class BackButton {
  private scene: Phaser.Scene;
  private targetSceneKey: string;
  private mBackButton: Phaser.GameObjects.Image;

  private static readonly TEXTURE_KEY = "back_button";

  /**
   * Call this from your Scene.preload()
   */
  public static preload(scene: Phaser.Scene): void {
    scene.load.image(BackButton.TEXTURE_KEY, "images/back_button.png");
  }

  /**
   * @param scene         The scene this button lives in
   * @param targetScene   Key of the scene to switch to on click
   * @param x             Optional X (defaults to bottom-left)
   * @param y             Optional Y (defaults to bottom-left)
   */
  constructor(
    scene: Phaser.Scene,
    targetScene: string,
    x?: number,
    y?: number
  ) {
    this.scene = scene;
    this.targetSceneKey = targetScene;

    // Default: bottom-left corner
    const defaultX = x ?? 0;
    const defaultY = y ?? scene.scale.height;

    this.mBackButton = scene.add
      .image(defaultX, defaultY, BackButton.TEXTURE_KEY)
      .setOrigin(0, 1) // anchor to bottom-left
      .setInteractive({ useHandCursor: true });

    this.mBackButton.on("pointerup", () => {
      this.scene.scene.start(this.targetSceneKey);
    });

    ImageHelpers.SetHoverEffectOnImage(scene, this.mBackButton);
  }

  /** Change button position at runtime */
  public setPosition(x: number, y: number): this {
    this.mBackButton.setPosition(x, y);
    return this;
  }

  /** Access to the underlying image if you need extra tweaks */
  public get image(): Phaser.GameObjects.Image {
    return this.mBackButton;
  }

  /** Destroy the button cleanly */
  public destroy(): void {
    this.mBackButton.removeAllListeners();
    this.mBackButton.destroy();
  }
}
